import { NextSeo } from 'next-seo';
import { SubscriptionAndProfessionalServicesAgreementPT } from '@/screens/Legal/SubscriptionAndProfessionalServicesAgreementPT';

export default function SubscriptionAndProfessionalServicesAgreementPTPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Acordo de Assinatura e Serviços Profissionais (Subscription and Professional Services Agreement) | Loadsmart"
        description="Acordo de Assinatura e Serviços Profissionais - Loadsmart"
        canonical="https://loadsmart.com/pt/subscription-and-professional-services-agreement/"
        openGraph={{
          url: 'https://loadsmart.com/pt/subscription-and-professional-services-agreement/',
        }}
      />
      <SubscriptionAndProfessionalServicesAgreementPT />
    </>
  );
}
